import React from 'react';

function CommercialField({ value }) {
  if (!value) return <>-</>;

  if (value === 1) {
    return <>Responsabile di Zona</>;
  } else if (value === 2) {
    return <>Commerciale 1</>;
  } else if (value === 3) {
    return <>Commerciale 2</>;
  }

  return <>{value}</>;
}

export default CommercialField;
